<template>
  <div
    class="message-box d-flex border border-opacity-50 rounded"
    :class="[
      `text-${color}`,
      `border-${color}`,
      dense ? 'px-3 py-2' : 'px-4 py-3',
    ]"
  >
    <v-icon v-if="icon" class="mr-2 box-icon" size="26px" :icon="icon" />

    <div class="box-content">
      <div
        v-if="title"
        v-text="title"
        class="text-body-1 mb-1"
        :class="{ 'pr-6': closable }"
      />
      <div class="opacity-80 text-body-2">
        <slot>{{ text }}</slot>
      </div>
    </div>

    <v-btn
      v-if="closable"
      class="close-btn"
      size="x-small"
      icon
      @click="$emit('close')"
    >
      <v-icon size="24px" icon="mdi-close" />
    </v-btn>

    <span class="bg-layer" :class="[`bg-${color}`]" />
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps, type PropType } from "vue";

const props = defineProps({
  text: String,
  title: String,
  color: {
    type: String as PropType<"error" | "success">,
    default: "success",
  },
  dense: Boolean,
  closable: Boolean,
});

const icon = computed(() => {
  switch (props.color) {
    case "error":
      return "mdi-alert-outline";
    case "success":
      return "mdi-check-circle-outline";
    default:
      return null;
  }
});
</script>

<style lang="scss" scoped>
.message-box {
  position: relative;
  z-index: 1;

  .close-btn {
    position: absolute;
    top: 6px;
    right: 6px;
  }

  .bg-layer {
    position: absolute;
    z-index: -1;
    inset: 0;
    border-radius: inherit;
    opacity: 0.1;
  }
}
</style>
